import Fingerprint2 from 'fingerprintjs2'
//判断页面显示什么语言
var langArr=["/zh-CN/","/zh-TW/","/cs/","/da/","/nl/","/fi/","/fr/","/de/","/el/","/it/","/ja/","/no/","/pl/","/pt/","/ru/","/es/","/sv/","/hu/","/tr/"];
window.lang='en';
for(var i=0;i<langArr.length;i++){
    if(location.href.indexOf(langArr[i])>-1){
        lang=langArr[i].split('/')[1];
        break;
    }else{
        lang='en';
    }
};
// 请求接口地址
window.domain=".tipard.com";
window.post_url='';
window.accountHref='';
window.officeUrl="";
window.watermarkPost="";
if(location.hostname=="www.tipard.com" ||
location.hostname=="account.tipard.com" ||
location.hostname=="ja.tipard.com" ||
location.hostname=="fr.tipard.com" ||
location.hostname=="it.tipard.com" ||
location.hostname=="es.tipard.com" ||
location.hostname=="pt.tipard.com" ||
location.hostname=="sv.tipard.com" ||
location.hostname=="nl.tipard.com" ||
location.hostname=="fi.tipard.com" ||
location.hostname=="da.tipard.com" ||
location.hostname=="pl.tipard.com" ||
location.hostname=="hu.tipard.com" ||
location.hostname=="cs.tipard.com" ||
location.hostname=="el.tipard.com" ||
location.hostname=="no.tipard.com" ||
location.hostname=="tr.tipard.com" ||
location.hostname=="ru.tipard.com" ||
location.hostname=="ar.tipard.com" ||
location.hostname=="zh-tw.tipard.com"
){
    post_url="https://acctedge.tipard.com/v13/";
    accountHref="https://account.tipard.com/";
    officeUrl="https://www.tipard.com/";
    watermarkPost = 'https://rmwmss.tipard.com/v6/removeWM/'
}else{
    post_url="https://sandbox.acctedge.tipard.com/v13/";
    accountHref="https://sandboxaccount.tipard.com/";
    officeUrl="https://sandboxwww.tipard.com/";
    watermarkPost = 'https://rmwmss.tipard.com/test/removeWM/'
}
//获取浏览器唯一码
window.murmur=1;
var options = {'excludes': {'userAgent':true,'audio':true,'enumerateDevices':true,'fonts':true,'fontsFlash':true,'canvas':true}}
Fingerprint2.get(options, function (components) {
    // 参数
    const values = components.map(function (component) {
        return component.value;
    });
    // 指纹
    murmur = Fingerprint2.x64hash128(values.join(''), 31);
});

//获取cookie
window.getCookie=function(name){
    var prefix = name + "="
    var start = document.cookie.indexOf(prefix)
 
    if (start == -1) {
        return null;
    }
 
    var end = document.cookie.indexOf(";", start + prefix.length)
    if (end == -1) {
        end = document.cookie.length;
    }
 
    var value = document.cookie.substring(start + prefix.length, end)
    return unescape(value);
}
// 判断是否有为google登陆跳过来的
if(getCookie('google_key')){
    $.ajaxSettings.async = false;
    function MemberOauthInfo(){
        $.post(
            post_url+'account/google/oauth/info',
            {
                e_id:murmur,
                key:getCookie('google_key')
            },
            function(data){
                console.log(data);
                error_fn(data.error);
                setCookie('google_key',"",-1);
                switch(data.error){
                    case 0:
                        setCookie('user_google',JSON.stringify({'google_id_token':data.id_token}),90);
                        google_login()
                        break;
                    case 26701:
                        error(i18n[lang].error_26701);
                        break;
                    case 26702:
                        error(i18n[lang].error_26702);
                        break;
                    case 26703:
                        error(i18n[lang].error_26703);
                        break;
                    case 26704:
                        error(i18n[lang].error_26704);
                        break;
                    case 26705:
                        MemberOauthInfo();
                        break;
                }
            }
        ).fail(function(xhr){
            overtime(26799);
        });
    }
    MemberOauthInfo();
    $.ajaxSettings.async = true;
}
window.user='';
window.personal='';
window.userProfile=function(callback,fail){
    $.post(
        post_url+'account/profile',
        {
            e_id:user.e_id,
            t_id:user.t_id,
            token:user.token
        },
        function(data){
            console.log(data);
            personal=data;
            error_fn(data.error)
            switch(data.error){
                case 0:
                    $('.header .right>.login').removeClass('MemberLogin')
                    $('.header .right>.login>span').hide()
                    if(data.picture){
                        $('.login ul li div img').attr('src',data.picture);
                        $('.header .right>.login>img').attr('src',data.picture);
                    }
                    if(data.nickname){
                        $('.login ul li').eq(0).find('.name').html(HtmlUtil.htmlEncode(data.nickname));
                    }else{
                        if(data.email){
                            try{
                                var nickname=data.email.split('@')[0];
                            }catch(e){
                                console.log(e);
                            }
                            $('.login ul li').eq(0).find('.name').html(HtmlUtil.htmlEncode(nickname));
                        }else{
                            $('.login ul li').eq(0).find('.name').html(data['3rdparty'][0]['name']);
                        }
                    }
                    if(callback){
                        callback();
                    }
                    break;
                case 20901:
                    error(i18n[lang].error_20901);
                    if(fail){
                        fail();
                    }
                    break;
                case 20902:
                    error(i18n[lang].error_20902);
                    if(fail){
                        fail();
                    }
                    break;
            };
        }
    ).fail(function(xhr){
        overtime(20499);
    })
}

console.log(getCookie('user'));
if(getCookie('user')){
    user=JSON.parse(getCookie('user'));
    //查询资料
    userProfile()
    //退出登录
    $('.logout').click(function(e){
        e.stopPropagation();
        $.post(
            post_url+'account/logout',
            {
                e_id:user.e_id,
                t_id:user.t_id,
                token:user.token
            },
            function(data){
                error_fn(data.error);
                switch(data.error){
                    case 0:
                        $('.login_btn>a').show();
                        $('.login_box').hide();
                        setCookie("user","",-1)
                        break;
                    case 20401:
                        error(i18n[lang].error_20401);
                        break;
                }
            }
        ).fail(function(xhr){
            overtime(20499);
        })
    });
}else{
    $('.login_btn>a').show();
    $('.login_box').hide();
};
$('.login_btn>a').attr('href',accountHref+'login?source='+location.href);
//google登录接口函数
function google_login(callback,registerCallback,mergeCallback){
    $.post(
        post_url+'account/google/login',
        {
            e_id:murmur,
            id_token:JSON.parse(getCookie('user_google')).google_id_token
        },
        function(data){
            console.log(data);
            error_fn(data.error);
            switch(data.error){
                case 0:
                    setCookie('user',JSON.stringify({'e_id':murmur,'t_id':data.t_id,'token':data.token}),90);
                    break;
                case 21601:
                    error(i18n[lang].error_21601);
                    break;
                case 21602:
                    error(i18n[lang].error_21602);
                    break;
                case 21603:
                    error(i18n[lang].error_21603);
                    break;
                case 21604:
                    error(i18n[lang].error_21604);
                    break;
                case 21605:
                    // 不提示，自动去创建账号并登录
                    if(registerCallback){
                        registerCallback()
                        return false;
                    }
                    third_party_registered_fn(0);
                    break;
                case 21606:
                    error(i18n[lang].error_21606);
                    break;
                case 21607:
                    // 不提示，不去注册，跳转是否合并邮箱页面
                    if(mergeCallback){
                        mergeCallback()
                        return false;
                    }
                    location.href=accountHref+"3rd-login-merge-account";
                    break;
                case 21608:
                    //自动帮忙注册一个账号
                    if(registerCallback){
                        registerCallback()
                        return false;
                    }
                    third_party_registered_fn(0);
                    break;
                case 21609:
                    // 不提示，不去注册，跳转是否合并邮箱页面
                    if(mergeCallback){
                        mergeCallback()
                        return false;
                    }
                    location.href=accountHref+"3rd-login-merge-account";
                    break;
                case 21610:
                    // 不提示，自动去注册一个3方账号并登录；创建成功后选择绑定，自动填充获得的Google 邮箱，同21608
                    if(registerCallback&&mergeCallback){
                        registerCallback()
                        mergeCallback()
                        return false;
                    }
                    third_party_registered_fn(0);
                    location.href=accountHref+"3rd-login-merge-account";
                    break;
                case 21611:
                    error(i18n[lang].error_21611);
                    break;
            }
        }
    ).fail(function(xhr){
        overtime(21699);
    })
};
// google账号注册
function third_party_registered_fn(operation,callback,callbackGoogle){
    if(!isnetwork()){return false;};
    let data={
        e_id:murmur,
        id_token:JSON.parse(getCookie('user_google')).google_id_token
    };
    console.log(operation);
    switch(operation){
        case 0:
            data={
                e_id:murmur,
                id_token:JSON.parse(getCookie('user_google')).google_id_token
            }
            break;
        case 21607:
            data={
                e_id:murmur,
                id_token:JSON.parse(getCookie('user_google')).google_id_token,
                connect:1
            }
            break;
        case 21608:
            break;
        case 21609:
            break;
        case 21610:
            break;
    }
    $.post(
        post_url+'account/google/register',data,
        function(data){
            console.log(data);
            error_fn(data.error);
            switch(data.error){
                case 0:
                    setCookie('user',JSON.stringify({'e_id':murmur,'t_id':data.t_id,'token':data.token}),90);
                    if(operation==21607){
                        if(callback){
                            callback();
                            return false;
                        }
                    }else{
                        if(callback){
                            callback();
                            return false;
                        }
                    }
                    break;
                case 21801:
                    error(i18n[lang].error_21801);
                    break;
                case 21802:
                    error(i18n[lang].error_21802);
                    break;
                case 21803:
                    error(i18n[lang].error_21803);
                    break;
                case 21804:
                    error(i18n[lang].error_21804);
                    break;
                case 21805:
                    if(callbackGoogle){
                        callbackGoogle()
                        return false;
                    }
                    google_login()
                    break;
                    // 不提示，重新三方登录到新的账号上
                case 21806:
                    error(i18n[lang].error_21806);
                    break;
                case 21807:
                    error(i18n[lang].error_21807);
                    break;
                case 21808:
                    error(i18n[lang].error_21808);
                    break;
                case 21809:
                    error(i18n[lang].error_21809);
                    break;
                case 21810:
                    error(i18n[lang].error_21810);
                    break;
                case 21811:
                    error(i18n[lang].error_21811);
                    break;
                case 21812:
                    error(i18n[lang].error_21812);
                    break;
                case 21813:
                    error(i18n[lang].error_21813);
                    break;
                case 21814:
                    error(i18n[lang].error_21814);
                    break;
                case 21815:
                    error(i18n[lang].error_21815);
                    break;
                case 21816:
                    error(i18n[lang].error_21816);
                    break;
                case 21817:
                    error(i18n[lang].error_21817);
                    break;
                case 21818:
                    error(i18n[lang].error_21818);
                    break;
                case 21819:
                    error(i18n[lang].error_21819);
                    break;
                case 21820:
                    error(i18n[lang].error_21820);
                    break;
                case 21821:
                    error(i18n[lang].error_21821);
                    break;
                case 21822:
                    error(i18n[lang].error_21822);
                    break;
                case 21823:
                    error(i18n[lang].error_21823);
                    break;
                case 21824:
                    error(i18n[lang].error_21824);
                    break;
                case 21825:
                    error(i18n[lang].error_21825);
                    break;
                case 21826:
                    error(i18n[lang].error_21826);
                    break;
            }
        }
    ).fail(function(xhr){
        overtime(21899);
    })
}
// 判断是否有网
function isnetwork(){
    if(!navigator.onLine){
        error(i18n[lang].isnetwork);
        return false;
    }else{
        return true;
    }
};

var HtmlUtil = {
    /*1.用浏览器内部转换器实现html转码*/
    htmlEncode:function (html){
        //1.首先动态创建一个容器标签元素，如DIV
        var temp = document.createElement ("div");
        //2.然后将要转换的字符串设置为这个元素的innerText(ie支持)或者textContent(火狐，google支持)
        (temp.textContent != undefined ) ? (temp.textContent = html) : (temp.innerText = html);
        //3.最后返回这个元素的innerHTML，即得到经过HTML编码转换的字符串了
        var output = temp.innerHTML;
           temp = null;
           return output;
    },
    /*2.用浏览器内部转换器实现html解码*/
    htmlDecode:function (text){
        //1.首先动态创建一个容器标签元素，如DIV
        var temp = document.createElement("div");
        //2.然后将要转换的字符串设置为这个元素的innerHTML(ie，火狐，google都支持)
        temp.innerHTML = text;
        //3.最后返回这个元素的innerText(ie支持)或者textContent(火狐，google支持)，即得到经过HTML解码的字符串了。
        var output = temp.innerText || temp.textContent;
        temp = null;
        return output;
    }
};
//失败
window.error=function(txet){
    $('body').append('<div class="error"><img width="16" height="16" src="https://account.tipard.com/images/error-2.svg" alt="Error">'+txet+'</div>');
    setTimeout(function(){
        $('body>.error').fadeOut();
    },5000);
}
$(document).click(function(){
    $('body>.success').fadeOut();
    $('body>.error').fadeOut();
});
// 超时错误
window.overtime=function(num){
    error(i18n[lang].overtime_1+num+i18n[lang].overtime_2);
}
window.error_fn=function(id){
    switch(id){
        case 20001:
            error(i18n[lang].error_20001);
            if($(window).width()>980){
                $('.header .right span').show();
            }
            $('.header .right .login img').attr('src',oldImgUrl)
            $('.header .right .login').addClass('MemberLogin');
            setCookie("user","",-1)
            user="";
            return false;
            break;
        case 20002:
            error(i18n[lang].error_20002);
            if($(window).width()>980){
                $('.header .right span').show();
            }
            $('.header .right .login img').attr('src',oldImgUrl)
            $('.header .right .login').addClass('MemberLogin');
            user="";
            setCookie("user","",-1)
            return false;
            break;
        case 20003:
            error(i18n[lang].error_20003);
            if($(window).width()>980){
                $('.header .right span').show();
            }
            $('.header .right .login img').attr('src',oldImgUrl)
            $('.header .right .login').addClass('MemberLogin');
            user="";
            setCookie("user","",-1)
            return false;
            break;
        case 20004:
            error(i18n[lang].error_20004);
            return false;
            break;
        case 20005:
            if($(window).width()>980){
                $('.header .right span').show();
            }
            $('.header .right .login img').attr('src',oldImgUrl)
            $('.header .right .login').addClass('MemberLogin');
            user="";
            setCookie("user","",-1)
            return false;
            break;
        case 20006:
            error(i18n[lang].error_20006);
            return false;
            break;
        case 20007:
            error(i18n[lang].error_20007);
            if($(window).width()>980){
                $('.header .right span').show();
            }
            $('.header .right .login img').attr('src',oldImgUrl)
            $('.header .right .login').addClass('MemberLogin');
            user="";
            setCookie("user","",-1)
            return false;
            break;
        case 20008:
            error(i18n[lang].error_20008);
            if($(window).width()>980){
                $('.header .right span').show();
            }
            $('.header .right .login img').attr('src',oldImgUrl)
            $('.header .right .login').addClass('MemberLogin');
            user="";
            setCookie("user","",-1)
            return false;
            break;
        case 20009:
            error(i18n[lang].error_20009);
            if($(window).width()>980){
                $('.header .right span').show();
            }
            $('.header .right .login img').attr('src',oldImgUrl)
            $('.header .right .login').addClass('MemberLogin');
            user="";
            setCookie("user","",-1)
            return false;
            break;
    }
    return true;
}
window.setCookie=function(name,value,iDay){
    var oDate = new Date();
    oDate.setDate(oDate.getDate() + iDay);
    if(location.hostname.indexOf('.tipard.com')>-1){
        document.cookie = name + '=' + value + ';path=/;domain='+domain+';expires=' + oDate;
    }else{
        document.cookie = name + '=' + value + ';path=/;expires=' + oDate;
    }
}

// 判断是否有传参进入
window.getQueryVariable=function(variable)
{
       var query = window.location.search.substring(1);
       var vars = query.split("&");
       for (var i=0;i<vars.length;i++) {
               var pair = vars[i].split("=");
               if(pair[0] == variable){return pair[1];}
       }
       return(false);
}
$(document).on('click','.MemberLogin',function(){
    if(String($(this).attr('class').indexOf('MemberLogin'))>-1){
        $('.maskMember').show()
    }
})